'use client';

import { useCallback, useEffect } from 'react';
import { memoizeTrackScrolling } from 'utils';
/**
 * TrackScrolling component sets up a scroll event listener to track scrolling behavior. It uses a memoized function to ensure
 * that the scroll tracking is efficient and does not cause performance issues. This component does not render any UI elements.
 * It only sets up the scroll tracking functionality.
 *
 * @example
 * ```jsx
 * import { TrackScrolling } from 'components/TrackScrolling';
 * function App() {
 *   return (
 *    <div>
 *     <TrackScrolling />
 *     <OtherComponents />
 *    </div>
 * *   );
 * @returns null
 */

export function TrackScrolling() {
  const trackScrolling = useCallback(memoizeTrackScrolling(100), []);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, []);

  // This component does not render anything, it only sets up the scroll tracking
  return null;
}
